/** User-facing names for the two v2 WAF event tables. */
export const LAYERD_SIGNATURE_WAF_LABEL = "Layerd Signature WAF";
export const LAYERD_AI_SMART_PARSE_LABEL = "Layerd AI Smart Parse";

const SIGNATURE_KEYS = new Set([
  "signature_waf",
  "signature",
  "crs",
  "sd_sig",
  "layerd-v2-signature-events",
  "layerd-v2-waf-events",
  0,
]);

const SMART_PARSE_KEYS = new Set([
  "smart_parse",
  "smartparse_waf",
  "layerd-v2-smartparse-events",
  1,
  4,
]);

/** Map API `_src`, `waf_type`, or `source_table` to a display label. */
export function getWafSourceDisplayLabel(value) {
  if (value === null || value === undefined || value === "") return null;
  if (typeof value === "number") {
    if (value === 0) return LAYERD_SIGNATURE_WAF_LABEL;
    if (value === 1 || value === 4) return LAYERD_AI_SMART_PARSE_LABEL;
    return null;
  }
  const key = String(value).toLowerCase();
  if (SIGNATURE_KEYS.has(key)) return LAYERD_SIGNATURE_WAF_LABEL;
  if (SMART_PARSE_KEYS.has(key)) return LAYERD_AI_SMART_PARSE_LABEL;
  return null;
}

/** Format WAF type for drawers and detail panels. */
export function formatWafTypeDisplay(value, fallback = "-") {
  return getWafSourceDisplayLabel(value) || fallback;
}

const timeSeriesBucketKey = (item) => {
  const k = item?.key_as_string ?? item?.key;
  return k == null || k === "" ? null : String(k);
};

const timeSeriesToMap = (arr) => {
  const m = new Map();
  for (const item of arr || []) {
    const k = timeSeriesBucketKey(item);
    if (k) m.set(k, Number(item.doc_count) || 0);
  }
  return m;
};

/** Parse API bucket key to epoch ms for Apex datetime series. */
function bucketKeyToMs(k) {
  if (k == null || k === "") return null;
  if (typeof k === "number" && Number.isFinite(k)) return k;
  const asStr = String(k).trim();
  if (/^\d{10,13}$/.test(asStr)) {
    const n = Number(asStr);
    return asStr.length <= 10 ? n * 1000 : n;
  }
  const t = new Date(k).getTime();
  return Number.isFinite(t) ? t : null;
}

/**
 * Align signature + smart parse buckets on one x-axis for area/line charts.
 * Without this, ApexCharts connects only each series' own sparse points (misleading "hand-off" lines).
 * Returns [timestampMs, count] pairs.
 */
export function alignWafDetectionTimeSeries(sigs, smartparses) {
  const keys = new Set();
  for (const item of sigs || []) {
    const k = timeSeriesBucketKey(item);
    if (k) keys.add(k);
  }
  for (const item of smartparses || []) {
    const k = timeSeriesBucketKey(item);
    if (k) keys.add(k);
  }
  const sorted = Array.from(keys).sort();
  const sigMap = timeSeriesToMap(sigs);
  const spMap = timeSeriesToMap(smartparses);

  return {
    signature: sorted
      .map((k) => {
        const t = bucketKeyToMs(k);
        return t == null ? null : [t, sigMap.get(k) ?? 0];
      })
      .filter(Boolean),
    smartParse: sorted
      .map((k) => {
        const t = bucketKeyToMs(k);
        return t == null ? null : [t, spMap.get(k) ?? 0];
      })
      .filter(Boolean),
  };
}
